export const selectWelcomeOffer = (campaigns) => {
    const welcomeOffers = campaigns ? campaigns.filter(c =>  c.welcomeOffer) : []

    return welcomeOffers.length === 1 ? welcomeOffers[0] : null
}

export const selectCampaignsWithoutWelcomeOffer = (campaigns) => {
    return campaigns ? campaigns.filter(c =>  !c.welcomeOffer) : []
}